<template>
  <SitecoreLink
    v-if="showComponent"
    :iconField="this.fields.LinkIcon"
    :linkField="this.fields.Link"
    :class="
      this.fields.LargeText.value ? 'footer__icon-link footer__icon-link--large' : 'footer__icon-link'
    "
    v-on:click.native="trackAnalytics(fields)"
    :editable="false"
   ></SitecoreLink>
</template>

<script>
import SitecoreLink from '../../Sitecore/SitecoreLink';
export default {
  name: 'FooterIconLink',
  components: {
    SitecoreLink,
  },
  data() {
    return {
      isAuthenticated: false,
    };
  },
  mounted: async function() {
    this.isAuthenticated = await this.$auth.isAuthenticated();
  },
  props: {
    fields: {
      type: Object,
      default: () => ({
        LinkIcon: null,
        Link: null,
        LargeText: false,
      }),
    },
    params: {
      type: Object,
    },
  },
  computed: {
    showComponent: function() {
      return (
        !this.params ||
        !this.params.displayAuthenticatedCondition ||
        this.params.displayAuthenticatedCondition === '0' ||
        (this.params.displayAuthenticatedCondition === '1' && this.isAuthenticated) ||
        (this.params.displayAuthenticatedCondition === '-1' && !this.isAuthenticated)
      );
    },
  },
  methods: {
    trackAnalytics(fields) {
      if (fields.Link.value.text) {
        this.$store.dispatch('analytics', {
          actionName: 'Custom-Link-Click',
          entityChange: fields.Link.value.text,
        });
      }
    },
  },
};
</script>
<style lang="scss">
.footer__icon-link--large .v-list-item__title {
  font-size: 2rem;
  font-weight: 500;
}

.footer__icon-link:hover:not(.footer__icon-link--large) .v-list-item__title {
  text-decoration: underline;
}

.footer__icon-link .v-list-item__title {
  @include target-ie {
    flex: none;
  }
}
</style>
<style lang="scss" scoped>
.footer__icon-link{
  &::v-deep {
    .experience-editor-link{
      a {
          text-decoration: none;
          color: #fff;
      }
      a:hover{
        text-decoration: underline;
      }
    }        
  }
}
</style>
